/// <amd-module name="Release/Landing/HubContent/SelectPipelineView" />
import * as React from "react";
import { VssComponent, IVssComponentProperties, } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { localeFormat } from "VSS/Core/Util/String";

import { ZeroData } from "VSSUI/ZeroData";
import { announce } from "VSS/Core/Util/Accessibility";

import * as Resources from "Release/Landing/Resources";

export interface ISelectPipelineViewProps extends IVssComponentProperties {
    resourceText: string;
}

export class SelectPipelineView extends VssComponent<ISelectPipelineViewProps, {}> {
    // Announce that no pipeline is selected as this view is not accessible via keyboard and the user needs to know about this
    public componentDidUpdate(prevProps: ISelectPipelineViewProps) {
        const announceMessage = localeFormat(Resources.SelectPipelineRequestMessage, prevProps.resourceText);
        announce(announceMessage);
    }

    public render(): React.ReactNode {
        return (
            <div className={"select-pipeline-view flex flex-grow justify-center"}>
                <ZeroData
                    primaryText={localeFormat(Resources.SelectPipelineRequestMessage, this.props.resourceText)}
                    imageAltText={""}
                    imagePath={getAssetLocation(this.context.pageContext, "ms.vss-releaseManagement-web/release-landing/zerodata-release-management-new.png")}
                />
            </div>
        );
    }
}
